import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import OrderSteps from '../../component/views/checkout/orderSteps';
import './style.css';
import { PricingMaintenancePopUp } from './PricingMaintenancePopUp';
import { selectCartItems } from '../../../redux/slices/cartSlice';
import { useSelector } from 'react-redux';
import CentralizePriceCalculation from '../../../service/pricing/pricingService';

export default function Checkout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState('cart');
  const [priceSummary, setPriceSummary] = useState({ entries: {} });
  const [showMaintenancePopup, setShowMaintenancePopup] = useState(false);
  const [totalLMDCharges, setTotalLMDCharges] = useState(0); // Base LMD in INR
  const [gstOnLMD, setGstOnLMD] = useState(0); // GST on LMD shipping
  const [totalLMDWithGST, setTotalLMDWithGST] = useState(0); // Total LMD including GST
  const [shippingMethod, setShippingMethod] = useState('fulfillment'); // 'self-pickup' or 'fulfillment'
  const cart = useSelector(selectCartItems);

  // useEffect(() => {
  //   // Calculate dw, vw, and shipping charges for each variant on cart load
  //   (async () => {
  //     if (!cart || cart.length === 0) return;

  //     const filteredCart = cart.filter(c => c.product?._id);
  //     const filteredProducts = filteredCart.map(fc => {
  //       const newProduct = { ...fc.product, pricingMode: fc.pricingMode };
  //       newProduct.variants = fc.variants;
  //       return newProduct;
  //     });

  //     const LMD_Details = await CentralizePriceCalculation.calculateCartProductTotalLMD(filteredProducts);

  //     // console.log('[Checkout] LMD breakdown:', {
  //     //   'total dead weight (kg)': LMD_Details.totalDW,
  //     //   'total volumetric weight (kg)': Math.round(LMD_Details.totalVW ),
  //     //   'total quantity': LMD_Details.totalQuantity,
  //     //   'total LMD (INR)': LMD_Details.totalLMD,
  //     //   'GST on LMD (INR)': LMD_Details.gstOnLMD ?? 0,
  //     //   'total LMD with GST (INR)': LMD_Details.totalLMDWithGST ?? LMD_Details.totalLMD,
  //     // });
  //     // console.log('[Checkout] LMD_Details (raw):', LMD_Details);

  //     // Apply LMD charges only if shipping method is 'fulfillment'
  //     if (shippingMethod === 'fulfillment') {
  //       setTotalLMDCharges(LMD_Details.totalLMD);
  //       setGstOnLMD(LMD_Details.gstOnLMD || 0);
  //       setTotalLMDWithGST(LMD_Details.totalLMDWithGST || LMD_Details.totalLMD);
  //     } else {
  //       // Self pickup - no LMD charges
  //       setTotalLMDCharges(0);
  //       setGstOnLMD(0);
  //       setTotalLMDWithGST(0);
  //     }
  //   })();
  // }, [cart, shippingMethod]);

  useEffect(() => {
    // Determine current step based on pathname
    const path = location.pathname;
    if (path.includes('/checkout/payment')) {
      setCurrentStep('payment');
    } else if (path.includes('/checkout/address')) {
      setCurrentStep('address');
    } else {
      setCurrentStep('cart');
    }
  }, [location.pathname]);

  // Navigation handler that can be used by child components
  const navigateToStep = step => {
    switch (step) {
      case 'cart':
        navigate('/checkout/cart');
        break;
      case 'address':
        // Preserve navigation state when navigating to address
        navigate('/checkout/address', {
          state: location.state || {}
        });
        break;
      case 'payment':
        // Preserve navigation state when navigating to payment
        navigate('/checkout/payment', {
          state: location.state || {}
        });
        break;
      default:
        navigate('/checkout/cart');
    }
  };

  // Expose navigation function to child components via context or props
  // For now, we'll manage navigation through the parent
  const handleStepNavigation = step => {
    // Add validation logic here if needed
    // For example, prevent going to payment without address
    if (step === 'payment' && currentStep !== 'address') {
      // Could add validation here
      return;
    }
    navigateToStep(step);
  };

  return (
    <div className="checkout-container">
      {/* <PricingMaintenancePopUp
        onClose={() => {
          setShowMaintenancePopup(false);
          navigate(-1);
        }}
      /> */}
      <OrderSteps currentStep={currentStep} onStepClick={handleStepNavigation} />
      <div className="checkout-content">
        <Outlet context={{ totalLMDCharges, gstOnLMD, totalLMDWithGST, shippingMethod, setShippingMethod, navigateToStep, currentStep, priceSummary, setPriceSummary, setShowMaintenancePopup }} />
      </div>
    </div>
  );
}
